export default {
  setSelectedPlatform(state, payload) {
    state.selectedPlatform = payload;
  },
};
